import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RequestParams } from 'Models'
import { Addresses } from 'Pages/orders_design'

export type SberGeoUnitState = {
	addresses: Addresses
	addressesParams: RequestParams
}

export const sberGeoUnitInitialState: SberGeoUnitState = {
	addresses: new Addresses(),
	addressesParams: new RequestParams(),
}

export namespace sberGeoUnitNS {
	export type getAddresses = PayloadAction
	export type getAddressesWithParams = PayloadAction<{
		params?: RequestParams
	}>
	export type setAddresses = PayloadAction<Addresses>
	export type setAddressesParams = PayloadAction<RequestParams>
}

export const sberGeoUnitSlice = createSlice({
	name: 'sberGeoUnit',
	initialState: sberGeoUnitInitialState,
	reducers: {
		getAddresses: (state, action: sberGeoUnitNS.getAddresses) => {},
		getAddressesWithParams: (state, action: sberGeoUnitNS.getAddressesWithParams) => {},
		setAddresses: (state, action: sberGeoUnitNS.setAddresses) => {
			state.addresses = action.payload
		},
		setAddressesParams: (state, action: sberGeoUnitNS.setAddressesParams) => {
			state.addressesParams = action.payload
		},
	},
})
